import getFilterWithCol from '../../helpers/getFilterWithCol';

// import Types from '../../common/modules/types';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { _id: { REGEX: value, OPTIONS: 'i' } },
        { name: { REGEX: value, OPTIONS: 'i' } },
      ],
    },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search By Name or ID',
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
  ].map(args => getFilterWithCol(...args)),
  filterPagination,
];
